export default {
  setUsers(state, userResult) {
    state.userResult = userResult;
  },
};
